import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchDlq, retryDlqItem, type DlqListParams } from '../lib/admin-notifications-api';

export const dlqKeys = {
  all: ['admin-notifications', 'dlq'] as const,
  list: (params: DlqListParams) => [...dlqKeys.all, params] as const,
};

export function useDlq(params: DlqListParams = {}) {
  return useQuery({
    queryKey: dlqKeys.list(params),
    queryFn: () => fetchDlq(params),
    staleTime: 30_000,
  });
}

export function useRetryDlqItem() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => retryDlqItem(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: dlqKeys.all }),
  });
}
